import { fuego } from '@nandorojo/swr-firestore';

export async function deletePostingInSeries({
  seriesId,
  docId,
  collectionPath,
}) {
  const seriesRef = fuego.db.collection(`${collectionPath}Series`);

  if (seriesId) {
    const getSeries = await seriesRef.doc(seriesId).get();

    if (getSeries.data()) {
      const idList = getSeries.data()!.postingList;

      const copyIdList = idList.slice();
      // idList에서 targetId의 index값 찾고, splice(index,1)로 도려내기
      const findIndex = copyIdList.findIndex((id) => id === docId);
      copyIdList.splice(findIndex, 1);
      //잘라낸 결과값은 copyIdList에 있음

      return seriesRef
        .doc(seriesId)
        .set({ postingList: copyIdList }, { merge: true });
    }
  }
}

export async function deleteSeries({ docId, collectionPath }) {
  const seriesRef = fuego.db.collection(`${collectionPath}Series`);

  // 해당 시리즈 docid를 포함하고있는 포스트에서 id 제거해주기
  const seriesPostingIdList = await seriesRef
    .doc(docId)
    .get()
    .then((res) => {
      return res.data().postingList;
    });
  await Promise.allSettled(
    seriesPostingIdList.map(async (postingId) => {
      await fuego.db
        .collection(collectionPath)
        .doc(postingId)
        .set({ series: '' }, { merge: true });
    }),
  );

  return seriesRef.doc(docId).delete();
}
